import React from 'react';
import {
  Box,
  Chip,
  Typography,
  Paper,
  TablePagination
} from '@mui/material';
import TablePaginationActions from '../../../components/TablePaginationAction';
import { useCatalogContext } from './CatalogContext';

const CatalogPagination = () => {
  const {
    page,
    handleChangePage,
    rowsPerPage,
    handleChangeRowsPerPage,
    totalCount,
    produtos,
    loading,
    viewMode
  } = useCatalogContext();

  const isMobile = window.innerWidth < 600;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        mt: 2, // Remove top margin
        mb: 1, // Remove bottom margin
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        bgcolor: '#fafafa',
        borderTop: '1px solid #eee',
        px: { xs: 0, sm: 0, md: 0 } // Remove horizontal padding
      }}
    >
      {/* Estatísticas e seleção em massa */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip
          label={`${totalCount} Produtos`}
          variant="outlined"
          size="small"
          sx={{
            fontWeight: 'medium',
            bgcolor: '#f7f7f7',
            borderColor: '#e0e0e0'
          }}
        />

        <Typography variant="body2" color="text.secondary" sx={{ px: 1 }}>
          {!loading && `Mostrando ${produtos.length} ${viewMode === 'grid' ? 'cards' : 'itens'}`}
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          p: 0, // Remove all padding
          display: 'flex',
          justifyContent: 'center',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          flexGrow: { xs: 1, md: 0 },
          width: { xs: '100%', md: 'auto' }
        }}
      >
        <TablePagination
          rowsPerPageOptions={[30, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
          labelRowsPerPage={isMobile ? "" : <span style={{ paddingLeft: 12 }}>Itens por página:</span>}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
          }
          sx={{
            minWidth: 0,
            boxShadow: 'none',
            m: 0,
            p: 0,
            '.MuiTablePagination-toolbar': {
              px: { xs: 0, sm: 0 },
              minHeight: 'unset',
              m: 0,
              p: 0
            },
            '.MuiTablePagination-select': {
              py: 0
            },
            '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
              fontWeight: 600,
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '.MuiTablePagination-spacer': {
              display: { xs: 'none', sm: 'block' }
            }
          }}
        />
      </Paper>
    </Box>
  );
};

export default CatalogPagination;
